<div class="branding">
  <a href="/" *ngIf="options">
    <div class="logo-container">
      <!-- Collapsed state - show icon only -->
      <img
        *ngIf="options.theme === 'light' && options.sidenavCollapsed"
        src="./assets/images/logos/origin_icon_light.svg"
        width="40"
        height="40"
        alt="logo icon"
        class="logo-icon"
      />
      <img
        *ngIf="options.theme !== 'light' && options.sidenavCollapsed"
        src="./assets/images/logos/origin_icon_dark.svg"
        width="40"
        height="40"
        alt="logo icon"
        class="logo-icon"
      />

      <!-- Expanded state - show full logo -->
      <img
        *ngIf="options.theme === 'light' && !options.sidenavCollapsed"
        src="./assets/images/logos/origin_logo_light.svg"
        width="180"
        alt="logo"
        class="logo-full"
      />
      <img
        *ngIf="options.theme !== 'light' && !options.sidenavCollapsed"
        src="./assets/images/logos/origin_logo_dark.svg"
        width="180"
        alt="logo"
        class="logo-full"
      />
    </div>
  </a>
</div>
